import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '../constants';
import { removeCookie } from '../utils/helper';

const getAccessTokenKey = () => `${ACCESS_TOKEN_KEY}_web`;

const getRefreshTokenKey = () => `${REFRESH_TOKEN_KEY}_web`;

export const clearLegacyAccessTokenCookie = (): void => {
	removeCookie(getAccessTokenKey());
};

export const clearLegacyRefreshTokenCookie = (): void => {
	removeCookie(getRefreshTokenKey());
};
